import * as React from "react"
import Logo from "../images/logo.webp"
import { Link } from "gatsby"

const Nav = () => {
  const [mobileMenuActive, setMobileMenuActive] = React.useState(false)

  return (
    <div className="relative z-20">
      <div className="flex justify-between max-w-screen-xl mx-auto items-center px-5 relative">
        <a href="/">
          <img
            src={Logo}
            alt="The Indoor Gardens - Logo"
            width="275px"
            height="95px"
          />
        </a>
        <div>
          <div className="fill-current hover:text-primary transition-all cursor-pointer">
            {!mobileMenuActive ? (
              <svg
                onClick={() => setMobileMenuActive(!mobileMenuActive)}
                className="lg:hidden"
                xmlns="http://www.w3.org/2000/svg"
                height="48px"
                viewBox="0 0 32 32"
                width="48px"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
              </svg>
            ) : (
              <svg
                onClick={() => setMobileMenuActive(!mobileMenuActive)}
                className="lg:hidden"
                xmlns="http://www.w3.org/2000/svg"
                height="48px"
                viewBox="0 0 32 32"
                width="48px"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
              </svg>
            )}
          </div>
          <ul
            className={`MobileMenu w-full ${
              mobileMenuActive ? "MenuOpen" : ""
            } px-4 md:px-0`}
            style={{ top: "100%" }}
          >
            <Link to={"/posts"} itemProp="url" className="">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Posts
              </li>
            </Link>
            <Link to={"/categories/fruits"} itemProp="url">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Fruits
              </li>
            </Link>
            <Link to={"/categories/veggies"} itemProp="url">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Veggies
              </li>
            </Link>
            <Link to={"/categories/herbs"} itemProp="url">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Herbs
              </li>
            </Link>
            <Link to={"/categories/flowers"} itemProp="url">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Flowers
              </li>
            </Link>
            <Link to={"/categories/care"} itemProp="url">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Care
              </li>
            </Link>
            <Link to={"/categories/cacti"} itemProp="url">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Cacti
              </li>
            </Link>
            <Link to={"/culinary"} itemProp="url">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Culinary
              </li>
            </Link>
            <Link to={"/design"} itemProp="url">
              <li className="lg:inline-block px-2.5 transition-all hover:text-primary">
                Design
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Nav
